// extracted by mini-css-extract-plugin
export default {"titleSection":"style_titleSection__coIWp","left":"style_left__9zHRk","center":"style_center__0VJG9","titleLink":"style_titleLink__4gQiu"};